<template>
  <div :class="className" v-bind="$attrs">
    <slot />
  </div>
</template>

<script>
import { shortcut } from '@/mixins/helpers'

export default {
  name: 'Tabs',

  props: {
    value: {
      type: Number,
      default: 0
    },
    className: {
      type: String,
      default: 'c-tabs'
    },
    activeClassName: {
      type: String,
      default: 'is-active'
    }
  },

  mixins: [ shortcut ],

  data () {
    return {
      currentTabIndex: this.value || 0
    }
  },

  provide () {
    return {
      activeClassName: this.activeClassName,
      currentTabIndex: () => this.currentTabIndex,
      setSelected: (index) => this.onSelect(index)
    }
  },

  mounted () {
    this.isValid(this.value)

    this.$watch(() => this.value, tabIndex => this.onSelect(tabIndex), { immediate: true })
    this.$watch(() => this.currentTabIndex, currentTabIndex => this.$emit('input', currentTabIndex))
  },

  computed: {
    shortcuts () {
      return Array.from({ length: this.tabCount }, (value, index) => index).map(index => ({ combinations: `shift+${index + 1}`, action: 'keypress', handler: () => this.onSelect(index) }))
    },

    tabCount () {
      return this.$children.find(item => item.$vnode.tag.includes('TabList')).$children.filter(item => item.$vnode.tag.includes('Tab')).length
    },

    tabContentCount () {
      return this.$children.find(item => item.$vnode.tag.includes('TabContainer')).$children.filter(item => item.$vnode.tag.includes('TabContent')).length
    }
  },

  methods: {
    isValid (tabIndex) {
      if (this.$children.length === 2) {
        if (this.tabCount === this.tabContentCount) {
          if (this.isValidTabIndex(tabIndex) === false) {
              this.currentTabIndex = 0
          }
        } else {
            throw new Error('There should be an equal number of <Tab/> and <TabContent/> components.')
          }
      } else {
        throw new Error('There should be exactly one of each <TabList/> and <TabContainer/> component.')
      }
    },

    isValidTabIndex (tabIndex) {
      const tab = this.$children.find(item => item.$vnode.tag.includes('TabList')).$children.filter(item => item.$vnode.tag.includes('Tab'))[tabIndex]

      return tabIndex >= 0 && tabIndex <= this.tabCount && tab.isDisabled === false
    },

    onSelect (tabIndex) {
      if (!this.isValidTabIndex(tabIndex)) {
          throw new Error('Tried to selected a non-existing or disabled tab.')
      }

      if (tabIndex !== this.currentTabIndex) {
        this.currentTabIndex = tabIndex
      }
    }
  }
}
</script>
